<template>
  <div class="animated fadeIn orden-trabajo-produccion">
    <b-row v-if="!modal">
      <b-col xl="12">
        <app-presupuesto-interno
          :labelCols="labelCols"
          :presupuestoNumero="presupuestoInterno.presupuestoNumero"
          :cliente="presupuestoInterno.cliente"
          :accion="presupuestoInterno.accion"
          :prioridad="presupuestoInterno.prioridad"
          :fechaRegistro="presupuestoInterno.fechaRegistro"
          :fechaEntrega="presupuestoInterno.fechaEntrega"
          :showMoneda="true"
          :moneda="presupuestoInterno.moneda"
          :monedaCotizacion="presupuestoInterno.monedaCotizacion"
          :usuarios="presupuestoInterno.usuarios"
          :showHeaderInit="Boolean(false)">
        </app-presupuesto-interno>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header="Información de la Orden" class="collapsable-card">
            <b-btn 
                class="btn-collapse-card" 
                v-if="!modal"
                variant="primary" 
                size="sm"
                @click.prevent="showInformacionOrden= !showInformacionOrden">
              <i :class="showInformacionOrden ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
            </b-btn>
            <b-collapse id="header" class="mt-2" v-model="showInformacionOrden">
              <b-row>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="Nro.Orden"
                    label-for="id"
                    :label-cols="labelCols"
                    horizontal>
                    <b-form-input 
                      id="id"
                      :value="id" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>  

                  <b-form-group
                    label="Rubro"
                    label-for="rubro"
                    :label-cols="labelCols"
                    horizontal>
                    <b-form-input 
                      id="rubro"
                      :value="rubroTrabajo" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>  

                  <b-form-group
                    label="Título"
                    label-for="titulo"
                    :label-cols="labelCols"
                    horizontal>
                    <b-form-input 
                      id="titulo"
                      :value="titulo" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>  

                  <b-form-group
                    label="Descripcion"
                    label-for="descripcion"
                    :label-cols="labelCols"
                    description="Descripción para el Cliente (incluida en el Presupuesto Interno)"
                    horizontal>
                    <b-form-textarea
                      id="descripcion"
                      :value="descripcion" 
                      rows="3"
                      max-rows="6"
                      readonly>
                    </b-form-textarea>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="6">
                  <b-form-group
                    label="Moneda"
                    label-for="moneda"
                    :label-cols="labelCols*2"
                    horizontal>
                    <b-form-input 
                      id="moneda"
                      :value="moneda" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Cantidad"
                    label-for="cantidad"
                    :label-cols="labelCols*2"
                    horizontal>
                    <b-form-input 
                      id="cantidad"
                      :value="cantidad" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Costo Estimado"
                    label-for="costoEstimado"
                    :label-cols="labelCols*2"
                    class="costos"
                    horizontal>
                    <b-form-input 
                      id="costoEstimadoTotal"
                      v-model.trim="$v.costoEstimadoTotal.$model" 
                      type="text"
                      v-if="!readOnly"
                      :state="costoEstimadoTotalValido"
                      @blur.native="validate">
                    </b-form-input>
                    <b-form-input 
                      id="costoEstimadoTotal"
                      :value="costoEstimadoTotal | moneda(moneda)" 
                      type="text"
                      v-if="readOnly"
                      readonly>
                    </b-form-input>
                    <b-form-input 
                      id="costoUnitarioEstimado"
                      :value="costoUnitarioEstimado | moneda(moneda)" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <b-form-group
                    label="Costo Subtrabajos"
                    label-for="costoProveedor"
                    :label-cols="labelCols*2"
                    class="costos"
                    horizontal>
                    <b-form-input 
                      id="costoProveedor"
                      :value="costoProveedor | moneda" 
                      type="text"
                      readonly>
                    </b-form-input>
                    <b-form-input 
                      id="costoUnitarioProveedor"
                      :value="costoUnitarioProveedor | moneda" 
                      type="text"
                      readonly>
                    </b-form-input>
                  </b-form-group>

                  <small class="form-text text-muted leyenda-costos">Costos Totales / Unitarios - Iva no incluido</small>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>

          <b-card  header="Lista de Subtrabajos">
            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes"
                :busy="tableBusy"
                :items="subtrabajosDatos"
                :fields="subtrabajosFields">
              <div slot="table-busy" class="text-center">
                <b-spinner class="table-spinner" label="Spinning" />
              </div>
              
              <template v-slot:cell(cantidad)="data">
                <template v-if="data.item.ordenProveedorId != 0 | data.item.costoRemitos | presupuestoCerrado">
                  {{ data.item.cantidad }}
                </template>
                <input type="number"
                    v-model="data.item.cantidad"
                    v-if="data.item.ordenProveedorId == 0 & !data.item.costoRemitos & !presupuestoCerrado"
                    @focus="$event.target.select()"
                    @keyup.enter.prevent="actualizarDatos(data.item)"
                    @change="actualizarDatos(data.item)"/>
                <!-- <input type="number"
                    v-model="data.item.cantidad"
                    v-if="data.item.ordenProveedorId == 0 & !data.item.costoRemitos & !presupuestoCerrado"
                    @input="actualizarDatos(data.item)"/> -->
              </template>
              
              <template v-slot:cell(costo)="data">
                <template v-if="data.item.ordenProveedorId != 0 | !data.item.costoUnitario | data.item.costoRemitos | presupuestoCerrado">
                  {{ data.item.costo | moneda(data.item.moneda) }}
                </template>
                <template v-if="data.item.ordenProveedorId == 0 & data.item.costoUnitario & !data.item.costoRemitos & !presupuestoCerrado">
                  {{ data.item.moneda }}
                  <input type="number"
                      step="0.01"
                      v-model="data.item.costo"
                      @focus="$event.target.select()"
                      @keyup.enter.prevent="actualizarCosto(data.item)"
                      @change="actualizarCosto(data.item)"/>
                  <!-- <input type="number"
                      step="0.01"
                      v-model="data.item.costo"
                      @input="actualizarCosto(data.item)"/> -->
                </template>  
              </template>

              <template v-slot:cell(costoTotal)="data">
                <template v-if="data.item.ordenProveedorId != 0 | data.item.costoUnitario | data.item.costoRemitos | presupuestoCerrado">
                  {{ data.item.costoTotal | moneda(data.item.moneda) }}
                </template>
                <template v-if="data.item.ordenProveedorId == 0 & !data.item.costoUnitario & !data.item.costoRemitos & !presupuestoCerrado">
                  {{ data.item.moneda }}
                  <input type="number"
                      step="0.01"
                      v-model="data.item.costoTotal"
                      @focus="$event.target.select()"
                      @keyup.enter.prevent="actualizarCostoTotal(data.item)"
                      @change="actualizarCostoTotal(data.item)"/>
                  <!-- <input type="number"
                      step="0.01"
                      v-model="data.item.costoTotal"
                      @input="actualizarCostoTotal(data.item)"/> -->
                </template>
              </template>
              
              <template v-slot:cell(diasProduccion)="data">
                <template v-if="data.item.ordenProveedorId != 0 | presupuestoCerrado">
                  {{ data.item.diasProduccion }}
                </template>
                <input type="number"
                    v-model="data.item.diasProduccion"
                    v-if="data.item.ordenProveedorId == 0 & !presupuestoCerrado"
                    @focus="$event.target.select()"
                    @keyup.enter.prevent="actualizarDatos(data.item)"
                    @change="actualizarDatos(data.item)"/>
                <!-- <input type="number"
                    v-model="data.item.diasProduccion"
                    v-if="data.item.ordenProveedorId == 0 & !presupuestoCerrado"
                    @input="actualizarDatos(data.item)"/> -->
              </template>
              
              <template v-slot:cell(opciones)="data">
                <template v-if="subtrabajosSeleccionados & !presupuestoCerrado">
                  <b-form-checkbox
                      v-model="data.item.selected"
                      v-if="subtrabajosSeleccionados 
                        & data.item.proveedorId == proveedorSeleccionado
                        & data.item.monedaId == monedaSeleccionada 
                        & data.item.ordenProveedorId == 0
                        & !data.item.costoRemitos"
                      :value="Boolean(true)"
                      :unchecked-value="Boolean(false)">
                  </b-form-checkbox> 
                </template>
                
                <template v-if="!subtrabajosSeleccionados & !presupuestoCerrado">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item 
                        v-if="data.item.ordenProveedorId == 0"
                        @click.stop="editarSubtrabajo(data.item)">
                      <i class="fa fa-edit"></i>Editar Datos del Subtrabajo</b-dropdown-item>
                    <b-dropdown-item
                        v-if="opcionActualizarSubtrabajo"
                        @click.stop="moverSubtrabajo(data.item)">
                      <i class="fa fa-share"></i>Mover Subtrabajo</b-dropdown-item>
                    <b-dropdown-item 
                        v-if="data.item.ordenProveedorId == 0
                          & !data.item.remitos"
                        @click.stop="borrarSubtrabajo(data.item)">
                      <i class="fa fa-remove"></i>Borrar Subtrabajo</b-dropdown-item>
                    <b-dropdown-item 
                        v-if="!subtrabajosSeleccionados 
                          & data.item.proveedorId != 0 
                          & data.item.ordenProveedorId == 0
                          & !data.item.costoRemitos"
                        @click.stop="seleccionarSubtrabajo(data.item)">
                      <i class="fa fa-check"></i>Seleccionar Subtrabajo</b-dropdown-item>
                    <b-dropdown-item 
                        v-if="!subtrabajosSeleccionados 
                          & data.item.proveedorId != 0 
                          & data.item.ordenProveedorId == 0
                          & !data.item.costoRemitos"
                        @click.stop="emitirOrden(data.item)">
                      <i class="fa fa-edit"></i>Emitir Orden al Proveedor</b-dropdown-item>
                    <b-dropdown-item 
                        v-if="!subtrabajosSeleccionados & data.item.ordenProveedorId != 0"
                        @click.stop="anularOrden(data.item)">
                      <i class="fa fa-close"></i>Anular Orden al Proveedor</b-dropdown-item>
                    <b-dropdown-item 
                        v-if="data.item.ordenProveedorId != 0"
                        @click.stop="exportarOrden(data.item)">
                      <i class="fa fa-file-pdf-o"></i>Exportar Orden al Proveedor</b-dropdown-item>
                    
                    <b-dropdown-divider v-if="opcionAgregarEvaluacion && data.item.ordenProveedorId != 0"></b-dropdown-divider>
                  
                    <b-dropdown-item 
                        v-if="opcionAgregarEvaluacion && data.item.ordenProveedorId != 0"
                        :disabled="data.item.evaluada || data.item.noEvaluar"
                        @click.stop="agregarEvaluacion(data.item)">
                      <i class="fa fa-star"></i>Evaluar Proveedor</b-dropdown-item>
                  </b-dropdown>
                </template>

                <template v-if="presupuestoCerrado">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template slot="button-content">
                      <i class="fa fa-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item 
                        v-if="data.item.ordenProveedorId != 0"
                        @click.stop="exportarOrden(data.item)">
                      <i class="fa fa-file-pdf-o"></i>Exportar Orden al Proveedor</b-dropdown-item>
                  </b-dropdown>

                  <b-dropdown-divider v-if="opcionAgregarEvaluacion && data.item.ordenProveedorId != 0"></b-dropdown-divider>
                  
                  <b-dropdown-item 
                      v-if="opcionAgregarEvaluacion && data.item.ordenProveedorId != 0"
                      :disabled="data.item.evaluada || data.item.noEvaluar"
                      @click.stop="agregarEvaluacion(data.item)">
                    <i class="fa fa-star"></i>Evaluar Proveedor</b-dropdown-item>
              </template>
              </template>

              <template v-slot:cell(detailShowing)="row">
                <b-btn class="detailShowing" 
                    size="sm" 
                    v-if= 'row.item.observaciones != ""'
                    @click.stop="row.toggleDetails">
                  {{ ( row.detailsShowing) ? '-' : '+' }}
                </b-btn>            
              </template>
              <template v-slot:row-details="row">
                <div v-if='row.item.observaciones != ""'>
                  <b-row>
                    <b-col xl="12">
                      <p class="orden-descripcion"> {{ row.item.observaciones }} </p>
                    </b-col>
                  </b-row>
                </div> 
              </template>
            </b-table>

            <b-table 
                small 
                responsive="sm"
                class="registro-ordenes totales" 
                :items="subtrabajosDatosTotales" 
                :fields="subtrabajosTotalesFields">
              <template v-slot:cell(costoTotal)="data">
                {{ data.item.costoTotal | moneda }}
              </template>
            </b-table>

            <div class="add-table-btn" v-if="!presupuestoCerrado">
              <div class="list-add-btn" @click.prevent="agregarSubtrabajo">
                  <i class="fa fa-plus" aria-hidden="true"></i>
              </div>
            </div>
          </b-card>

          <b-card header="Información de Producción"  class="collapsable-card" v-if="!modal">
            <b-btn class="btn-collapse-card" 
                variant="primary" 
                size="sm"
                @click.prevent="showDescripcionProduccion= !showDescripcionProduccion">
              <i :class="showDescripcionProduccion ? 'fa fa-caret-up' : 'fa fa-caret-down'"></i>
            </b-btn>
            <b-collapse id="header" class="mt-2" v-model="showDescripcionProduccion">
              <b-form-group>
                <b-form-textarea
                  id="descripcionProduccion"
                  v-model="$v.descripcionProduccion.$model" 
                  rows="5"
                  max-rows="5"
                  :state="descripcionProduccionValida"
                  @blur.native="validate">
                </b-form-textarea>
                <b-form-invalid-feedback id="descripcionProduccionFeedback">
                  {{ descripcionProduccionInvalidaMsj }}
                </b-form-invalid-feedback>          
              </b-form-group>
            </b-collapse>
          </b-card>

        </b-form>
      </b-col>
    </b-row>

    <b-modal ref="subtrabajoModal" 
        title="Datos del Subtrabajo"
        modal-class="modalABM modalOrdenSubtrabajo"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-subtrabajo
        @updateSubtrabajo="updateSubtrabajo"
        @closeSubtrabajo="closeSubtrabajo">
      </app-subtrabajo>  
    </b-modal>

    <b-modal ref="ordenProveedorModal" 
        title="Emitir Orden al Proveedor"
        modal-class="modalABM modalOrdenProveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-orden-proveedor
        :modal="Boolean(true)"
        @updateOrdenProveedor="updateOrdenProveedor"
        @closeOrdenProveedor="closeOrdenProveedor">
      </app-orden-proveedor>  
    </b-modal>

    <div class="fixed-btn" v-if="!modal">
      <div class="data-xls-btn" 
        v-b-tooltip.hover title="Emitir Orden al Proveedor"
        v-if="subtrabajosSeleccionados"
        @click.prevent="emitirOrdenSeleccionados">
          <i class="fa fa-edit fa-2x" aria-hidden="true"></i>
      </div>
      <div class="abm-cancel-btn" 
        v-b-tooltip.hover title="Cancelar Selección"
        v-if="subtrabajosSeleccionados"
        @click.prevent="cancelarSeleccion">
          <i class="fa fa-close fa-2x" aria-hidden="true"></i>
      </div>

      <div class="abm-save-continue-btn" 
        v-if="!subtrabajosSeleccionados & !presupuestoCerrado"
        @click.prevent="saveContinue"
        v-b-tooltip.hover title="Grabar y Continuar">
          <i class="fa fa-save" aria-hidden="true" style="position: relative; font-size: 1.6em; left: -2px; top: 3px;"></i>
          <i class="fa fa-share" aria-hidden="true" style="position: relative; font-size: 0.8em; left: -2px; top: -11px;"></i>
      </div>
      <div class="abm-save-btn" 
        v-if="!subtrabajosSeleccionados & !presupuestoCerrado"
        @click.prevent="save"
        v-b-tooltip.hover title="Grabar y Salir">
          <i class="fa fa-save fa-2x" aria-hidden="true"></i>
      </div>
      <div class="abm-cancel-btn" 
        v-if="!subtrabajosSeleccionados & !presupuestoCerrado"
        @click.prevent="goBack"
        v-b-tooltip.hover title="Salir">
          <i class="fa fa-close fa-2x" aria-hidden="true"></i>
      </div>
      <div class="data-goback-btn" 
        v-if="presupuestoCerrado"
        @click.prevent="goBack"
        v-b-tooltip.hover title="Salir">
          <i class="fa fa-undo fa-2x" aria-hidden="true"></i>
      </div>
    </div>

    <b-modal ref="searchPresupuestoInternoModal" 
        title="Seleccionar Presupuesto Interno"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-search-presupuesto
        :soloPresupuestosAbiertos="true"
        :seleccionarSubtrabajo="false"
        :opcionAgregarSubtrabajo="false"
        @presupuestoInternoSeleccionado="presupuestoInternoSeleccionado"
        @cancelaSeleccionPresupuestoInterno="cancelaSeleccionPresupuestoInterno">
      </app-search-presupuesto>  
    </b-modal>

    <b-modal ref="evaluacionProveedorModal"
        title="Evaluación del Proveedor"
        modal-class="modalABM modalEvaluacionProveedor"
        header-bg-variant= "light" 
        hide-footer
        lazy>
      <app-evaluacion-proveedor
        :ordenProveedorId="ordenProveedorId"
        @close="closeEvaluacionProveedor">
      </app-evaluacion-proveedor>  
    </b-modal>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>

    <confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </confirm>
  </div>
</template>

<script>
import Subtrabajo from './Subtrabajo.vue';
import PresupuestoInternoDatos from '../shared/presupuestoInterno';
import OrdenProveedor from '../ordenesproveedores/ABM.vue';
import EvaluacionProveedor from '../evaluacionesProveedores/ABM.vue';
import SearchPresupuesto from '../presupuestosinternos/Search.vue';
import exportPDFOrdenProveedor from '../../mixins/export_orden_proveedor_pdf';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import { required, numeric, decimal, maxLength, minValue, maxValue } from 'vuelidate/lib/validators';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'ordentrabajoproduccion/getField',
  mutationType: 'ordentrabajoproduccion/updateField',
});

export default {
  name: 'ABM',
  components: {
    appSubtrabajo: Subtrabajo,
    appPresupuestoInterno: PresupuestoInternoDatos,
    appOrdenProveedor: OrdenProveedor,
    appEvaluacionProveedor: EvaluacionProveedor,
    appSearchPresupuesto: SearchPresupuesto,
    Mensaje,
    Confirm
  },
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    ordenTrabajoId: {
      type: Number,
      default: 0
    }
  },
  mixins: [
    exportPDFOrdenProveedor,
    msjModal, 
    confirmModal 
  ],
  data () {
    return {
      saveOptionsModal: false,

      descripcionProduccionValida: null,
      descripcionProduccionInvalidaMsj: '',
      costoEstimadoTotalValido: null,
      costoEstimadoTotalInvalidoMsj: '',

      subtrabajosFields: [
        {
            key: 'detailShowing',
            label: '',
            class: 'text-center'
        },
        {
          key: 'ordenSubtrabajoId',
          label: 'Nro.',
          class: 'text-right'
        },
        {
          key: 'nombre',
          label: 'Tipo de Artículo',
          sortable: true
        },
        {
          key: 'cantidad',
          class: 'text-right'
        },
        {
          key: 'costo',
          label: 'Costo Unit.',
          class: 'text-right'
        },
        {
          key: 'costoTotal',
          label: 'Costo Total',
          class: 'text-right'
        },
        {
          key: 'proveedor',
          label: 'Proveedor'
        },
        {
          key: 'diasProduccion',
          label: 'Dias',
          class: 'text-right' 
        },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      subtrabajosTotalesFields: [
        {
            key: 'col01',
        },
        {
          key: 'totales',
          class: 'text-center'
        },
        {
          key: 'costoTotal',
        },
        {
          key: 'col04',
        },
      ],

      subtrabajoSelected: null,
      ordenSubtrabajoId: 0,
      ordenProveedorId: 0,
      showInformacionOrden: true,
      showDescripcionProduccion: true,
      showCostos: true,
      opcionActualizarSubtrabajo: false,
      noValidar: true,
      tableBusy: false,
      labelCols: 2,
      routeNext: null,

      opcionAgregarEvaluacion: false,
    }
  },
  computed: {
    ...mapFields([
      'presupuestoInterno',

      'id',
      'presupuestoInternoId',
      'ordenTrabajo',
      'rubroTrabajo',
      'titulo',
      'descripcion',
      'descripcionProduccion',
      'cantidad',
      'moneda',
      'costoEstimadoTotal',
      'costoProveedor',
      'costoFinal',
      // 'costoUnitarioEstimado',
      'costoUnitarioProveedor',
      'costoUnitarioFinal',
      'readOnly',
      'certificado',
      // 'cerrada',
      'presupuestoCerrado',

      'subtrabajosDatos',
      'subtrabajosDatosTotales',

      'ordenSubtrabajoSeleccionado',
      'dirty'
    ]),

    subtrabajosSeleccionados() {
      let seleccionados = false;

      if (this.subtrabajosDatos) {
        if (this.subtrabajosDatos.length != 0) {
          let key = this.subtrabajosDatos.findIndex(a => a.selected);
          if (key != -1) {
            seleccionados = true;
          }
        }
      }

      return seleccionados;
    },
    proveedorSeleccionado() {
      let proveedorId = 0;

      if (this.subtrabajosDatos) {
        if (this.subtrabajosDatos.length != 0) {
          let subtrabajo = this.subtrabajosDatos.find(s => s.selected);
          if (subtrabajo) {
            proveedorId = subtrabajo.proveedorId;
          }
        }
      }

      return proveedorId;
    },
    monedaSeleccionada() {
      let monedaId = 0;

      if (this.subtrabajosDatos) {
        if (this.subtrabajosDatos.length != 0) {
          let subtrabajo = this.subtrabajosDatos.find(s => s.selected);
          if (subtrabajo) {
            monedaId = subtrabajo.monedaId;
          }
        }
      }

      return monedaId;
    },
    costoUnitarioEstimado() {
      if (this.cantidad == 0) {
        return 0;
      }
      return parseFloat(this.costoEstimadoTotal) / parseFloat(this.cantidad);
    }
  },  
  created() {
    this.opcionActualizarSubtrabajo = Boolean(this.$store.getters['user/tieneAccesoModulo']('PresupuestosInternosProduccionMoverSubtrabajo'));
    this.opcionAgregarEvaluacion = Boolean(this.$store.getters['user/tieneAccesoModulo']('OrdenesProveedoresAgregarEvaluacion'));

    let ordenTrabajoId = 0;

    if (!this.modal) {
      if (this.$route.params){
        if (this.$route.params.id){
          ordenTrabajoId = this.$route.params.id;
        }
      }
    } else {
      ordenTrabajoId= this.ordenTrabajoId;
    }
    
    let params = {
      ordenTrabajoId,
      loadPresupuesto: true
    }

    this.showSpinner();
    this.$store.dispatch('ordentrabajoproduccion/inicializar', params)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar) {
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'costoEstimadoTotal' || validarTodos) {
        if (this.$v.costoEstimadoTotal.$error) {
          this.costoEstimadoTotalValido = false;
          if (!this.$v.costoEstimadoTotal.decimal || !this.$v.costoEstimadoTotal.minValue) {
            this.costoEstimadoTotalInvalidoMsj = 'El costo estimado ingresado no es válido';
          }
        } else {
          this.costoEstimadoTotalValido = null;
          this.costoEstimadoTotalInvalidoMsj = '';
        }
      }

      if (campo == 'descripcionProduccion' || validarTodos) {
        if (this.$v.descripcionProduccion.$error) {
          this.descripcionProduccionValida = false;
          if (!this.$v.descripcionProduccion.maxLength) {
            this.descripcionProduccionInvalidaMsj = 'La descripción sólo puede contener hasta 500 caracteres';
          }
        } else {
          this.descripcionProduccionValida = null;
          this.descripcionProduccionInvalidaMsj = '';
        }
      }
    },
    saveOptions() {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.saveOptionsModal = true;
      }
    },
    save () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        this.$store.dispatch('ordentrabajoproduccion/save')
          .then(() => {
            let paramsOrden = {
              ordenTrabajoId: this.id,
              costoProveedor: this.costoProveedor
            }
            this.$store.dispatch('presupuestointernoproduccion/updateOrden', paramsOrden);
            return;
          })
          .then(() => {
            // console.log('Updated');
            this.$v.$reset();
            
            this.showModalMsj('Los cambios se registraron con éxito.', this.goBack, this.goList, 'light')
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    saveContinue () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;
      
      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {
        this.showSpinner();
        let params = {
          saveContinue: true
        }
        this.$store.dispatch('ordentrabajoproduccion/save', params)
          .then(() => {
            let paramsOrden = {
              ordenTrabajoId: this.id,
              costoProveedor: this.costoProveedor
            }
            this.$store.dispatch('presupuestointernoproduccion/updateOrden', paramsOrden);
            return;
          })
          .then(() => {
            this.$v.$reset();
            
            this.showModalMsj('Los cambios se registraron con éxito.', null, null, 'light')
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    goBack() {
      this.$router.push({ name: 'PresupuestoInternoProduccion', 
                    params: { id: parseInt(this.presupuestoInternoId) },
                    props: { inicializar: false } });

    },
    agregarSubtrabajo() {
      this.$store.dispatch('ordentrabajoproduccion/selectOrdenSubtrabajo')
        .then(() => {
          let params = {
            ordenTrabajoId: this.id,
          }
          this.$store.dispatch('ordenSubtrabajo/inicializar', params);
          this.$refs.subtrabajoModal.show();
        })
        .catch(error => this.showErrorMsj(error));
    },
    editarSubtrabajo(item) {
      this.$store.dispatch('ordentrabajoproduccion/selectOrdenSubtrabajo', item.ordenSubtrabajo)
        .then(() => {
          let params = {
            ordenTrabajoId: this.id,
            ordenSubtrabajo: item.ordenSubtrabajo
          }
          this.$store.dispatch('ordenSubtrabajo/inicializar', params);
          this.$refs.subtrabajoModal.show();
        })
        .catch(error => this.showErrorMsj(error));
    },
    updateSubtrabajo() {
      this.$refs.subtrabajoModal.hide();

      let ordenSubtrabajoSeleccionada = (/true/i).test(this.$store.getters['ordentrabajoproduccion/isOrdenSubtrabajoSeleccionada']);

      if (ordenSubtrabajoSeleccionada) {
        this.$store.dispatch('ordentrabajoproduccion/updateOrdenSubtrabajo', 
          this.$store.getters['ordenSubtrabajo/ordenSubtrabajo']);
      } else {
        this.$store.dispatch('ordentrabajoproduccion/addOrdenSubtrabajo', 
          this.$store.getters['ordenSubtrabajo/ordenSubtrabajo']);
      }
    },
    closeSubtrabajo() {
      this.$refs.subtrabajoModal.hide();
    },

    moverSubtrabajo(item) {
      /* Validamos que no haya cambios sin registrar */
      let dirty = false;
      if (this.subtrabajosDatos) {
        if (this.subtrabajosDatos.length != 0) {
          this.subtrabajosDatos.forEach(subtrabajo => {
            let ordenSubtrabajoId = 0;
            if (subtrabajo.ordenSubtrabajoId) {
              ordenSubtrabajoId = subtrabajo.ordenSubtrabajoId;
            }
            if (ordenSubtrabajoId == 0 || subtrabajo.dirty) {
              dirty = true;
            }
          });
        }
      }

      if (dirty) {
        this.showModalConfirm('Uno o más de los subtrabajos tienen información pendiente de guardar.\nDesea guardar la información en este momento?', 
          this.saveContinue, 'Si', null, 'No');
      } else {
        this.ordenSubtrabajoId = item.ordenSubtrabajoId;
        this.$refs.searchPresupuestoInternoModal;
        this.$refs.searchPresupuestoInternoModal.show()
      }
    },
    presupuestoInternoSeleccionado(params) {
      this.$refs.searchPresupuestoInternoModal.hide();

      params.ordenSubtrabajoId = this.ordenSubtrabajoId;

      if (params.presupuestoInterno) {
        if (params.presupuestoInterno.id) {
          params.presupuestoInternoId = params.presupuestoInterno.id;
        }
      }

      if (params.ordenTrabajo) {
        if (params.ordenTrabajo.id) {
          params.ordenTrabajoId = params.ordenTrabajo.id;
        }
      }

      this.showSpinner();
      this.$store.dispatch('ordenesSubtrabajos/moverSubtrabajo', params)
        .then(() => this.$store.dispatch('ordentrabajoproduccion/reinicializar'))
        .then(() => this.showModalMsj('El subtrabajo se actualizó con éxito.', null, null, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    cancelaSeleccionPresupuestoInterno() {
      this.$refs.searchPresupuestoInternoModal.hide()
    },

    borrarSubtrabajo(item) {
      this.$store.dispatch('ordentrabajoproduccion/selectOrdenSubtrabajo', item.ordenSubtrabajo)
        .then (() => this.showModalConfirm('¿Desea eliminar el subtrabajo seleccionado de la orden?',
            this.borrar, 'Si', null, 'No'))
        .catch(error => this.showErrorMsj(error));
    },
    borrar() {
      this.showSpinner();
      this.$store.dispatch('ordentrabajoproduccion/deleteOrdenSubtrabajo')
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    actualizarDatos(item) {
      let params = {
          ordenSubtrabajo: item.ordenSubtrabajo,
          cantidad: item.cantidad,
          diasProduccion: item.diasProduccion
      }

      this.tableBusy = true;
      this.$store.dispatch('ordentrabajoproduccion/updateOrdenSubtrabajoDatos', params)
        .catch (error => {
          this.showErrorMsj(error);

          item.cantidad = parseFloat(item.ordenSubtrabajo.cantidad);
          item.diasProduccion = item.ordenSubtrabajo.diasProduccion; 
        })
        .finally(() => this.tableBusy = false);
    },
    actualizarCosto(item) {
      let params = {
          ordenSubtrabajo: item.ordenSubtrabajo,
          costo: item.costo,
      }

      this.tableBusy = true;
      this.$store.dispatch('ordentrabajoproduccion/updateOrdenSubtrabajoCosto', params)
        .catch (error => {
          this.showErrorMsj(error);

          item.costo = parseFloat(item.ordenSubtrabajo.costo);
        })
        .finally(() => this.tableBusy = false);
    },
    actualizarCostoTotal(item) {
      let params = {
          ordenSubtrabajo: item.ordenSubtrabajo,
          costoTotal: item.costoTotal,
      }

      this.tableBusy = true;
      this.$store.dispatch('ordentrabajoproduccion/updateOrdenSubtrabajoCostoTotal', params)
        .catch (error => {
          this.showErrorMsj(error);

          item.costoTotal = parseFloat(item.ordenSubtrabajo.costoTotal);
        })
        .finally(() => this.tableBusy = false);
    },

    seleccionarSubtrabajo(item) {
      item.selected = !item.selected;
    },
    cancelarSeleccion() {
      this.subtrabajosDatos.forEach(t => t.selected = false);
    },
    emitirOrden(item) {
      // console.log(item);
      this.subtrabajoSelected = item;

      let ordenSubtrabajoId = 0;
      if (item.ordenSubtrabajoId) {
        ordenSubtrabajoId = item.ordenSubtrabajoId;
      }

      if (ordenSubtrabajoId == 0 || item.dirty) {
          let confirmMsj = '';
          if (ordenSubtrabajoId == 0) {
            confirmMsj = 'No se ha guardado aún la información del subtrabajo para emitir la orden al proveedor.\nDesea guardar la información en este momento?';
          } else if (item.dirty) {
            confirmMsj = 'El subtrabajo ha sido modificado, deberá guardar los cambios para emitir la orden correspondiente.\nDesea guardar la información en este momento?';
          }

          this.showModalConfirm(confirmMsj, this.saveContinue, 'Si', null, 'No');

      } else {
        let renglones = [];
        renglones.push({
          ordenTrabajoId: this.id,
          ordenSubtrabajoId: item.ordenSubtrabajo.ordenSubtrabajoId,
          articuloTipo: item.nombre,
          cantidad: item.ordenSubtrabajo.cantidad,
          importe: item.ordenSubtrabajo.costo,
          importeTotal: item.ordenSubtrabajo.costoTotal,
          precioUnitario: item.ordenSubtrabajo.costoUnitario,
        })
        
        let params = {
          presupuestoInternoId: this.presupuestoInternoId,
          proveedorId: item.proveedorId,
          proveedor: item.proveedor,
          monedaId: item.monedaId,
          moneda: item.moneda,
          renglones,

          costoRemitos: item.costoRemitos
        }

        this.$store.dispatch('ordenproveedor/addOrden', params)
          .then(() => {
            /* Modal de la orden al proveedor */
            this.$refs.ordenProveedorModal.show();
          })
      }
    },
    emitirOrdenSeleccionados() {
      let dirty = false;
      let seleccionados = this.subtrabajosDatos.filter(s => s.selected);
      if (seleccionados) {
        if (seleccionados.length != 0) {
          seleccionados.forEach(subtrabajo => {
            let ordenSubtrabajoId = 0;
            if (subtrabajo.ordenSubtrabajoId) {
              ordenSubtrabajoId = subtrabajo.ordenSubtrabajoId;
            }
            if (ordenSubtrabajoId == 0 || subtrabajo.dirty) {
              dirty = true;
            }
          });

          if (dirty) {
            this.showModalConfirm('Uno o más de los subtrabajos tienen información pendiente de guardar.\nDesea guardar la información en este momento?', 
              this.saveContinue, 'Si', null, 'No');

          } else {
            let renglones = [];
            let proveedor = '';
            seleccionados.forEach(subtrabajo => {
              if (subtrabajo.proveedorId == this.proveedorSeleccionado & subtrabajo.monedaId == this.monedaSeleccionada) {
                renglones.push({
                  ordenTrabajoId: this.id,
                  ordenSubtrabajoId: subtrabajo.ordenSubtrabajo.ordenSubtrabajoId,
                  articuloTipo: subtrabajo.nombre,
                  cantidad: subtrabajo.ordenSubtrabajo.cantidad,
                  importe: subtrabajo.ordenSubtrabajo.costo,
                  importeTotal: subtrabajo.ordenSubtrabajo.costoTotal,
                  precioUnitario: subtrabajo.ordenSubtrabajo.costoUnitario,
                })
                proveedor = subtrabajo.proveedor.trim();
              }
            });

            let params = {
              presupuestoInternoId: this.presupuestoInternoId,
              proveedorId: this.proveedorSeleccionado,
              proveedor,
              monedaId: this.monedaSeleccionada,
              renglones,

              costoRemitos: false
            }

            this.$store.dispatch('ordenproveedor/addOrden', params)
              .then(() => {
                /* Modal de la orden al proveedor */
                this.$refs.ordenProveedorModal.show();
              })
          }
        }
      }
        
    },

    updateOrdenProveedor(ordenProveedor) {
      this.$refs.ordenProveedorModal.hide();
      /* Actualizamos el estado del renglón */
      if (ordenProveedor) {
        if (ordenProveedor.renglones) {
          if (ordenProveedor.renglones.length) {
            ordenProveedor.renglones.forEach(renglon => {
              let subtrabajo = this.subtrabajosDatos
                .find(subtrabajo => subtrabajo.ordenSubtrabajo.ordenSubtrabajoId == renglon.ordenSubtrabajoId);
              if (subtrabajo) {
                subtrabajo.ordenProveedorId = ordenProveedor.id;
              }
            });
          }
        }
        
        this.subtrabajosDatos.forEach(subtrabajo => subtrabajo.selected = false);

        this.showModalConfirm('La orden se emitió con éxito. ¿Desea exportarla en este momento?', 
          this.exportarOrdenGenerada.bind(null, ordenProveedor.id), 'Si', null, 'No');
      }
    },
    closeOrdenProveedor() {
      this.$refs.ordenProveedorModal.hide();

      this.subtrabajosDatos.forEach(subtrabajo => subtrabajo.selected = false);
    },
    exportarOrdenGenerada(ordenProveedorId) {
      this.exportarOrdenProveedor(ordenProveedorId);
    },
    exportarOrden(item) {
      this.exportarOrdenProveedor(item.ordenProveedorId);
    },
    exportarOrdenProveedor(ordenProveedorId) {
      let empresa;
      this.showSpinner();
      this.$store.dispatch('empresa/inicializar')
        .then(() => {
          empresa = this.$store.getters['empresa/empresa'];
          return;
        })
        .then(() => {
          return this.$store.dispatch('ordenproveedor/getDatos', ordenProveedorId);
        })
        .then(() => {
          this.exportPDFOrdenProveedor(this.$store.getters['ordenproveedor/ordenProveedorDatosRpt'], empresa);
        })
        .catch( error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    anularOrden(item) {
      this.showModalConfirm('¿Desea anular la orden al proveedor?', 
          this.anular.bind(this, item.ordenProveedorId), 'Si', null, 'No');      
    },
    anular(ordenProveedorId) {
      this.showSpinner();
      this.$store.dispatch('ordenesproveedores/delete', ordenProveedorId)
        .then(() => {
          this.showModalMsj('La orden se anuló con éxito.', null, null, 'light')

          /* Actualizamos las referencias a la orden al proveedor */
          this.$store.dispatch('ordentrabajoproduccion/deleteOrdenProveedor', ordenProveedorId);
        })
        .catch( error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
    agregarEvaluacion(item) {
      this.ordenProveedorId = item.ordenProveedorId;
      this.$refs.evaluacionProveedorModal.show();
    },
    closeEvaluacionProveedor(saved) {
      this.$refs.evaluacionProveedorModal.hide();

      if (saved) {
        this.$store.dispatch('ordentrabajoproduccion/setOrdenProveedorEvaluada', this.ordenProveedorId);
      }
    },

    cancelarBeforeLeave(to) {
      /* Guardamos el parametro */
      this.routeNext = to;

      this.showModalConfirm('¿Desea salir sin registrar los cambios en la orden?', 
          this.leave, 'Si', null, 'No');      
    },
    leave() {
      this.$v.$reset();
      this.$store.dispatch('ordentrabajoproduccion/resetDirty');

      this.$router.push({ name: this.routeNext.name, 
                          params: this.routeNext.params});
    },    
  },
  beforeRouteLeave (to, from, next) {
    if (to.name.trim().toLowerCase() == 'login') {
      next();
    } else {
      if (this.$v.$anyDirty | this.dirty) {
        this.cancelarBeforeLeave(to);
        /* Cancelamos hasta que confirme el usuario */
        next(false);
      } else {
        next();
      }
    }
  },  
  validations: {
    costoEstimadoTotal: {
      decimal,
      minValue: minValue(0),
    },
    descripcionProduccion: {
      maxLength: maxLength(5000),
    },
  },  
}
</script>

<style>
  .orden-trabajo-produccion .abm-save-continue-btn {
    top: -5px;
  }
  .orden-trabajo-produccion div.costos input {
    display: inline-block;
    width: 45%;
  }
  .orden-trabajo-produccion div.costos input:nth-child(2) {
    margin-left: 3%;
  }

  .orden-trabajo-produccion .registro-ordenes table th {
    border-top: none;
  }
  .orden-trabajo-produccion .registro-ordenes table td {
    vertical-align: middle;
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="1"] {
    width: 30px;
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="2"] {
    width: 5%;
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="3"] {
    width: calc(32% - 30px);
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="4"] {
    width: 5%;
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="5"],
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="6"] {
    width: 12%;
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="7"] {
    width: calc(30% - 30px);
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="8"] {
    width: 6%;
  }
  .orden-trabajo-produccion .registro-ordenes table td[aria-colindex="9"] {
    width: 30px;
  }

  .orden-trabajo-produccion .registro-ordenes table td input {
    position: relative;
    width: 70%;
    left: 5%;
    margin: 0; 
    text-align: right;
    -moz-appearance:textfield;
    border: none;
    border-bottom: 1px solid rgba(32, 168, 216, 0.8);
  }
  .orden-trabajo-produccion .registro-ordenes table td input[type=number]::-webkit-inner-spin-button, 
  .orden-trabajo-produccion .registro-ordenes table td input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }

  .orden-trabajo-produccion .registro-ordenes.totales table td[aria-colindex="1"] {
    width: 40%;
  }
  .orden-trabajo-produccion .registro-ordenes.totales table td[aria-colindex="2"],
  .orden-trabajo-produccion .registro-ordenes.totales table td[aria-colindex="3"] {
    width: 12%;
  }
  .orden-trabajo-produccion .registro-ordenes.totales table td[aria-colindex="4"] {
    width: 46%;
  }

  /* Renglon de totales */
  .orden-trabajo-produccion .registro-ordenes.totales table {
    margin-bottom: 0;
  }
  .orden-trabajo-produccion .registro-ordenes.totales table th {
    display: none;
  }
  .orden-trabajo-produccion .registro-ordenes.totales table td {
    border: none;
  }
  .orden-trabajo-produccion .registro-ordenes.totales table tr {
    font-size: 1.2em;
  }

  .orden-trabajo-produccion .registro-ordenes p.orden-descripcion {
    margin-bottom: 5px;
    margin-left: 8%;
    width: 32%;
    white-space: pre-wrap;
  }

  .orden-trabajo-produccion small.leyenda-costos {
    text-align: right;
    margin-right: 30px;
  }

</style>
